import * as React from "react";
import { createComponent } from "@lit/react";
import Component from "../../components/Datepicker/sgds-datepicker";
import { register } from "../../utils/ce-registry";

register("sgds-datepicker", Component);

export default createComponent({
  react: React,
  tagName: "sgds-datepicker",
  elementClass: Component,
  events: {
    onSgdsChangeDate: "sgds-change-date",
    onSgdsInvalid: "sgds-invalid",
    onSgdsValid: "sgds-valid",
    onSgdsShow: "sgds-show",
    onSgdsAfterShow: "sgds-after-show",
    onSgdsHide: "sgds-hide",
    onSgdsAfterHide: "sgds-after-hide"
  }
});
